import { Platform } from 'react-native';

import styled from 'styled-components/native';
import { ColorProps, color, layout, LayoutProps } from 'styled-system';
import { Colors } from 'theme/colors';

const DEFAULT_HEIGHT = 50;

export const Touchable = styled.TouchableOpacity<ColorProps & LayoutProps>`
  align-items: center;
  height: ${DEFAULT_HEIGHT}px;
  justify-content: center;
  ${Platform.select({ web: 'outline-width: 0;' })}
  border-width: 1px;
  border-color: ${Colors.transparent};
  ${color}
  ${layout}
`;

/**
 * Circle containing the icon.
 */
export const IconContainer = styled.View`
  width: 35px;
  height: 35px;
  border-radius: 17.5px;
  background-color: ${Colors.mischka};
  position: absolute;
  top: 7.5px;
  right: 7.5px;
  justify-content: center;
  align-items: center;
`;
